import React from 'react';

import { decimal } from 'Helpers/currencyFormat';
import { formatFigure } from 'Helpers/formatService';

import LocalisedNumberFormat from 'CommonComponents/LocalisedNumberFormat';

// Stands in for the figure itself, so the shared rule decides blank / dash / "<0.01"
// and only a real rate reaches the number component. The floor's own step is
// formatted in the locale, like the number component.
const RENDER_FIGURE = '\u0000';

/**
 * The one place a rate becomes text. `currency` arrives null from the page's
 * data endpoint for an organisation with no currency set, and the figures then
 * render unsymboled.
 *
 * Whole rates stay whole — the rate card is hand-entered day rates, and forcing
 * two decimals onto every row buys nothing. No rate renders blank and a zero rate
 * as the dash.
 */
export default function RateCardRate({ value, currency }) {
    const text = formatFigure(value, (v, p) => (v === value ? RENDER_FIGURE : decimal(v, p)), { precision: 2 });

    if (text !== RENDER_FIGURE) {
        return text;
    }

    return <LocalisedNumberFormat value={value} displayType="text" thousandSeparator={true} decimalScale={2} prefix={currency?.symbol ?? ''} />;
}
